import * as React from "react";
import "./LandingNavigation.less";
import {observer} from "mobx-react";

export type LandingNavigationStates = {
    isWindowSmall: boolean,
    paused: boolean,
    reverse: boolean,
    isMenuOpen: boolean,
};

@observer
export default class CutLine extends React.Component<{}, LandingNavigationStates> {

    public render(): React.ReactNode {
        return (
            <div className="footer-cut-line"/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CutLine.tsx